import { call, put } from 'redux-saga/effects'
import UserActions from 'Redux/UserRedux'
import TeamActions from 'Redux/TeamRedux'
import { BuildErrorMsg } from './ApiHelpers'

export function * onUsersRequest (api, action) {
  const resp = yield call(api.getUsers)
  if (resp.ok) {
    yield put(UserActions.usersListSuccess(resp.data))
  } else {
    yield put(
      UserActions.usersListFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onUserShowRequest (api, action) {
  const resp = yield call(api.getUser, action.userId)
  if (resp.ok) {
    yield put(UserActions.usersShowSuccess(resp.data))
  } else {
    yield put(
      UserActions.usersShowFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onCreateUserRequest (api, action) {
  const resp = yield call(api.createUser, action.createParams)
  if (resp.ok) {
    yield put(UserActions.usersCreateSuccess(resp.data))
    yield put(UserActions.usersListRequest())
  } else {
    yield put(
      UserActions.usersCreateFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onUpdateUserRequest (api, action) {
  const resp = yield call(api.updateUser, action.id, action.updateParams)
  if (resp.ok) {
    yield put(UserActions.usersUpdateSuccess(resp.data))
  } else {
    yield put(
      UserActions.usersUpdateFailure(BuildErrorMsg(resp))
    )
  }
}

export function * onDeleteUsersRequest (api, action) {
  const resp = yield call(api.deleteUser, action.userId, {
    team_id: action.teamId
  })
  if (resp.ok) {
    yield put(UserActions.usersDeleteSuccess(resp.data))
    yield put(TeamActions.teamsListRequest())
  } else {
    yield put(
      UserActions.usersDeleteFailure(BuildErrorMsg(resp))
    )
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/UserSagas.js